import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { setPageClarityTags } from "lib/utils/helpers";
import { useEffect } from "react";

export const useClarity = () => {
  const {
    state: { checkoutView, checkoutModal },
  } = useCheckoutContext();

  const {
    state: { checkoutMetadata },
  } = useMerchantContext();
  const { initialCheckoutStep } = checkoutMetadata ?? {};

  useEffect(() => {
    if (initialCheckoutStep === "ADDRESS") return;
    if (checkoutModal === "ADDRESS_NEW") {
      return;
    }
    setPageClarityTags(checkoutView);
  }, [checkoutView, initialCheckoutStep, checkoutModal]);
};
